import React, { Component } from "react";
import { distinctUntilChanged } from "rxjs/operators";
import store from "./state/store";
import { searchFromForm } from "./state/helpers/searchFromForm";
import { checkRefGenomeDisabled } from "./state/actions/checkRefGenomeDisabled";
import SearchModal from "./components/atoms/SearchModal/SearchModal";
import { getTypeOfQuery } from "./common/helpers/helpers";
import { VARIANT_QUERY_LIST } from "./common/helpers/Constant";
import NavbarQueryFormSelect from "./NavbarQueryFormSelect";
import eventEmitter from "./components/eventEmitter";

const examples = [
  "rs746753722",
  "NM_017882.3(CLN6):c.679G>A",
  "SYNGR1:c.607_608insACA",
  "BRAF:V600E",
  " 5:156479558:15:",
  "7-151945072--T",
  "5:156479558",
  "BRAF",
  "NM_002482",
  "chr2:47630263:47639699:DEL",
  "AGTCCRAGTTGTAAATGGTACACTCGGCGTAAGCCTGAAAAGATAAAATCAAAGATGTAAAGGTGAGCACAGTCTAAGTTCTCTCTGAAGTGTCAATGGGAATGCAGATTGGATTAAATAAATGCTGCCCAAGTGCATACTCAAAGAGGC",
];

const dataHelpTourText = `You can search by various formats
            (see <a target="_blank" href="/about/examples/">Examples</a> for a complete description).
            <br/>
            Variants:
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/variant/hg19/BRAF V600E">
                BRAF V600E
            </a>
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/variant/hg19/BRAF c.1799T>A">
                BRAF c.1799T>A
            </a>
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/variant/hg19/chr7-140453136-A-T">
                chr7-140453136-A-T
            </a>
            <br/>
            Genes and transcripts:
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/gene/BRAF">BRAF</a><br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/transcript/hg19/NM_004333">
                NM_004333
            </a>
            <br/>
            Positions:
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/variant/hg19/BRAF c.1799">
                BRAF c.1799
            </a>
            <br/>
            <a target="_blank" href="${
              store.getState().varsomeHost
            }/position/hg19/chr7-140453136">
                chr7-140453136
            </a>`;

class NavbarQueryForm extends Component {
  constructor() {
    super();
    this.state = {
      userQuery: "",
      isSearchModalOpen: false,
    };
    this.closeAllSelect = this.closeAllSelect.bind(this);
    this.selectBoxClicked = this.selectBoxClicked.bind(this);
    this.hideInputExamples = this.hideInputExamples.bind(this);
    this.showInputExamples = this.showInputExamples.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
    this.queryChanged = this.queryChanged.bind(this);
  }

  componentDidMount() {
    function compareStoreState(a, b) {
      return a?.userQuery === b?.userQuery && a?.loading === b?.loading;
    }

    this.subscription = eventEmitter.storeUpdated$
      .pipe(distinctUntilChanged(compareStoreState))
      .subscribe({ next: this.mapStoreToState.bind(this) });
  }

  componentWillUnmount() {
    // eslint-disable-next-line no-undef
    $("#search-form-input").off("focus.search_form_input");
    this.subscription.unsubscribe();
  }

  handleInputClick() {
    const { userQuery } = this.state;
    this.showInputExamples(userQuery);
  }

  clearUserQuery = () => {
    this.setState({ userQuery: "" });
  };

  queryChanged = (e) => {
    const { value: userQuery } = e.target;
    this.showInputExamples(userQuery);
    checkRefGenomeDisabled(userQuery);
    this.setState({ userQuery });
  };

  onSearchClick = () => {
    const { userQuery } = this.state;
    const queryType = getTypeOfQuery(userQuery);
    store.dispatch({ type: "SET_USER_QUERY", userQuery });
    if (VARIANT_QUERY_LIST.includes(queryType)) {
      this.setState({ isSearchModalOpen: true });
    } else {
      searchFromForm(userQuery, true, null, null);
    }
  };

  mapStoreToState(storeState) {
    return this.setState({
      userQuery: storeState.userQuery,
      isLoading: storeState.loading,
    });
  }

  showInputExamples(query) {
    this.closeAllSelect();
    if (query) {
      this.hideInputExamples();
    } else {
      const results = document.getElementsByClassName("search-results");
      Array.from(results).forEach((x) => (x.style.display = "block"));
      setTimeout(
        () => document.addEventListener("click", this.hideInputExamples),
        0
      );
    }
  }

  hideInputExamples() {
    document.getElementsByClassName("search-results")[0].style.display = "none";
    document.removeEventListener("click", this.hideInputExamples);
  }

  itemClicked() {
    /* When an item is clicked, update the original select box, and the selected item div. */
    let i;
    let j;
    let selectItemsDiv;
    const selectTag =
      this.parentNode.parentNode.getElementsByTagName("select")[0];
    const selectSelectedDiv = this.parentNode.previousSibling;
    /* Update the original select element. */
    for (i = 0; i < selectTag.length; i++) {
      if (selectTag.options[i].innerHTML === this.innerHTML) {
        selectTag.selectedIndex = i;
        /* Dispatch an event so that handleGenomeChange function is triggered. */
        let event;
        if (typeof Event === "function") {
          event = new Event("change", { bubbles: true, cancelable: false });
        } else {
          event = document.createEvent("Event");
          event.initEvent("change", true, false);
        }
        selectTag.dispatchEvent(event);

        selectSelectedDiv.innerHTML = this.innerHTML;
        /* Highlight the selected item on the dropdown menu. */
        selectItemsDiv =
          this.parentNode.getElementsByClassName("same-as-selected");
        for (j = 0; j < selectItemsDiv.length; j++) {
          selectItemsDiv[j].removeAttribute("class");
        }
        this.setAttribute("class", "same-as-selected");
        break;
      }
    }
    /* Not sure why we have to click on selectSelectedDiv, provided with the script. */
    selectSelectedDiv.click();
  }

  selectBoxClicked(e) {
    /* When the select box is clicked, close any other select boxes and open/close the current select box. */
    e.stopPropagation();
    this.hideInputExamples();
    const selectSelectedDiv = e.target;
    this.closeAllSelect(selectSelectedDiv);
    selectSelectedDiv.nextSibling.classList.toggle("select-hide");
    selectSelectedDiv.classList.toggle("select-arrow-active");
    /*  Add listener  which closes all select boxes when the user clicks anywhere outside the select box. */
    document.addEventListener("click", this.closeAllSelect);
  }

  closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document, except the current select box. */
    let i;
    const arrNo = [];
    const selectItemsDiv = document.getElementsByClassName("select-items");
    const selectSelectedDiv =
      document.getElementsByClassName("select-selected");
    for (i = 0; i < selectSelectedDiv.length; i++) {
      if (elmnt === selectSelectedDiv[i]) {
        arrNo.push(i);
      } else {
        selectSelectedDiv[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < selectItemsDiv.length; i++) {
      if (arrNo.indexOf(i)) {
        selectItemsDiv[i].classList.add("select-hide");
      }
    }
    document.removeEventListener("click", this.closeAllSelect);
  }

  render() {
    const start = document.getElementById("start");
    const { userQuery, isSearchModalOpen, isLoading } = this.state;

    if (start) {
      start.className = start.className.replace("narrow-width-page", "");
    }

    return (
      <form
        className="form-inline search-box"
        id="variant-search-form"
        onSubmit={(e) => {
          this.onSearchClick();
          e.preventDefault();
        }}
        ref={(ref) => (this.inputAndButton = ref)}
        autoComplete="off"
      >
        <input
          autoComplete="off"
          data-helptour={dataHelpTourText}
          data-helppos="1"
          data-helptour-version="6.3.1"
          type="text"
          name="userQuery"
          id="search-form-input"
          className="form-control search help-tour wizard-searchInput"
          placeholder="Search"
          value={userQuery}
          onChange={this.queryChanged}
          onClick={this.handleInputClick}
        />
        <span className="clear-btn-span">
          <i
            className={`varsome-icons icon-close clear-btn ${
              userQuery ? "" : "tw-opacity-0 tw-pointer-events-none"
            }`}
            onClick={this.clearUserQuery}
          />
        </span>
        <NavbarQueryFormSelect searchQuery={userQuery} />

        <SearchModal
          show={isSearchModalOpen}
          handleClose={() => this.setState({ isSearchModalOpen: false })}
        />
        <div>
          <button
            type="button"
            data-helppos="5"
            data-helptour-version="9.2.1"
            data-helptour="Annotates the variant using Germline databases and Germline Variant Classification or by using additional cancer databases and AMP (for VarSome Premium users only)."
            data-tooltip-delay="700"
            onClick={() => this.onSearchClick()}
            className="prisma_btn prisma_btn--selected help-tour wizard-searchButtonHeader"
            disabled={isLoading}
          >
            <span className="text">Search</span>
          </button>
        </div>
        <div className="search-results nav-query-page">
          {examples.map((example) => (
            <div
              style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }} // needs to be kept inline
              key={example}
              onClick={(e) => searchFromForm(example, true, null, e)}
            >
              {example}
            </div>
          ))}
        </div>
      </form>
    );
  }
}

export default NavbarQueryForm;
